import React from 'react';
import { Link } from 'react-router-dom';
import edu from '../assets/EducationSchoolsmall.png';

const Education = () => {
  return (
    <div style={{ backgroundColor: '#000503', color: '#fff', minHeight: '100vh', padding: '40px' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '16px' }}>Education Network Solutions</h1>

        <img src={edu} alt="Education WiFi" style={{
          width: '100%', maxWidth: '600px', borderRadius: '12px', marginBottom: '30px'
        }} />

        <p style={{ color: '#a0aec0', lineHeight: '1.8', marginBottom: '24px', fontSize: '1.1rem' }}>
          Educational institutions rely on technology to enhance learning experiences. Sarvanta
          delivers tailored wireless network solutions for schools and campuses, ensuring seamless
          connectivity, robust security, and compliance with educational standards.
        </p>

        <h2 style={{ fontSize: '1.8rem', marginBottom: '16px' }}>Understanding Educational Needs</h2>
        <p style={{ color: '#a0aec0', lineHeight: '1.8', marginBottom: '24px', fontSize: '1.1rem' }}>
          Schools have diverse networking requirements — from separating student and faculty traffic
          to restricting device types and filtering content. Our platform addresses these needs with
          purpose-built features for the education sector.
        </p>

        <h2 style={{ fontSize: '1.8rem', marginBottom: '16px' }}>Empowering Learning</h2>
        <p style={{ color: '#a0aec0', lineHeight: '1.8', marginBottom: '40px', fontSize: '1.1rem' }}>
          Our cloud-managed solutions empower schools to create active learning environments and
          smart campuses, fostering collaboration and innovation while maintaining the security
          that parents and administrators expect.
        </p>

        <h2 style={{ fontSize: '1.8rem', marginBottom: '24px' }}>Key Features</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px', marginBottom: '40px' }}>
          {[
            { title: 'Network Segmentation', desc: 'Separate student, faculty, guest, and IoT device traffic with dedicated VLANs and security policies.' },
            { title: 'Device Restriction & Rate Limiting', desc: 'Control which devices can connect and how much bandwidth each consumes to ensure fair access for all.' },
            { title: 'Secure Authentication', desc: '802.1X authentication ensures only authorized users and devices access the network.' },
            { title: 'Content Filtering', desc: 'CIPA-compliant content filtering protects students from inappropriate material.' },
            { title: 'Seamless Connectivity', desc: 'Low-cost, high-security solutions that adapt to changing educational demands and growing device counts.' },
            { title: 'Cloud Management', desc: 'Centralized administration across all buildings and campuses from a single dashboard.' }
          ].map((item, i) => (
            <div key={i} style={{
              padding: '24px', backgroundColor: '#0a1628', borderRadius: '10px',
              border: '1px solid #1a2744'
            }}>
              <h3 style={{ fontSize: '1.1rem', marginBottom: '8px', color: '#60a5fa' }}>{item.title}</h3>
              <p style={{ color: '#a0aec0', lineHeight: '1.6', margin: 0, fontSize: '0.95rem' }}>{item.desc}</p>
            </div>
          ))}
        </div>

        <div style={{ padding: '24px', backgroundColor: '#0a1628', borderRadius: '10px', border: '1px solid #1a2744', textAlign: 'center' }}>
          <p style={{ color: '#a0aec0', marginBottom: '16px' }}>
            Explore key considerations before upgrading your school's network.
          </p>
          <Link to="/whitepapers" style={{
            padding: '12px 28px', backgroundColor: '#2563eb', color: '#fff',
            borderRadius: '8px', textDecoration: 'none', fontWeight: '600'
          }}>Download White Paper</Link>
        </div>
      </div>
    </div>
  );
};

export default Education;
